import { jsx as _jsx } from "react/jsx-runtime";
import { getIsUngatedForSeats } from 'pricing-pages-lib/utils/gatingUtils';
import { useContext } from 'react';
import { PRODUCT_VERSION } from 'self-service-api/constants/SkuTypes';
import { PlanBuilderContext } from '../../../context/PlanBuilderContext';
import { useAppSelector } from '../../../reducers';
import { isSalesOrServiceProOrEntSkuSelector, skuSelector } from '../../../selectors/ProductsSelectors';
import { usePricingLibSelector } from '../../../selectors/SelectorUtils';
import QuantityPacksPickerContainer from '../QuantityPacksPickerContainer';

const SuiteQuantityPackPickers = ({
  setProductLevel
}) => {
  const {
    productConfigurations,
    trackingSource
  } = useContext(PlanBuilderContext);
  const isSeatsRedesignUngated = usePricingLibSelector(getIsUngatedForSeats);
  const additionalUnitSkuIds = useAppSelector(state => productConfigurations.reduce((acc, productConfiguration) => {
    const {
      skuId
    } = productConfiguration;
    const sku = skuSelector(state, {
      skuId
    });

    if (sku.skuType === PRODUCT_VERSION) {
      const {
        quantifiable: isSkuQuantifiable
      } = sku;
      const isSalesOrServiceProOrEntSku = isSalesOrServiceProOrEntSkuSelector(state, {
        skuId
      });
      const skuIds = isSeatsRedesignUngated && isSkuQuantifiable && isSalesOrServiceProOrEntSku ? [skuId] : sku.quantityPackDetails.map(({
        skuId: quantityPackSkuId
      }) => quantityPackSkuId);
      return [...acc, ...skuIds];
    }

    return acc;
  }, []));
  return /*#__PURE__*/_jsx(QuantityPacksPickerContainer, {
    additionalUnitSkuIds: additionalUnitSkuIds,
    setProductLevel: setProductLevel,
    trackingSource: trackingSource
  });
};

export default SuiteQuantityPackPickers;